"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3500],{

/***/ 7500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ Link; }
/* harmony export */ });
/* unused harmony export NextLinkComposed */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(86010);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90948);
/* harmony import */ var next_translate_routes_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73966);
/* harmony import */ var next_translate_routes_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_translate_routes_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _mui_material_Link__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(23795);
/* harmony import */ var _contexts_CursorContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15888);












// Add support for the sx prop for consistency with the other branches.
var Anchor = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)("a")({});
var NextLinkComposed = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function NextLinkComposed(props, ref) {
    var to = props.to, linkAs = props.linkAs, replace = props.replace, scroll = props.scroll, shallow = props.shallow, prefetch = props.prefetch, locale = props.locale, storybook = props.storybook, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(props, [
        "to",
        "linkAs",
        "replace",
        "scroll",
        "shallow",
        "prefetch",
        "locale",
        "storybook"
    ]);
    return storybook ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
        href: to,
        prefetch: prefetch,
        as: linkAs,
        replace: replace,
        scroll: scroll,
        shallow: shallow,
        passHref: true,
        locale: locale,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(Anchor, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
            ref: ref
        }, other))
    }) : /* next-translate-routes/link is using the wrong Type for next/link. */ /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)((next_translate_routes_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: to,
        prefetch: prefetch,
        as: linkAs,
        replace: replace,
        scroll: scroll,
        shallow: shallow,
        passHref: true,
        locale: locale,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(Anchor, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
            ref: ref
        }, other))
    });
});
// A styled version of the Next.js Link component:
// https://nextjs.org/docs/api-reference/next/link
var Link = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Link(props, ref) {
    var _activeClassName = props.activeClassName, activeClassName = _activeClassName === void 0 ? "active" : _activeClassName, as = props.as, classNameProps = props.className, href = props.href, linkAsProp = props.linkAs, locale = props.locale, noLinkStyle = props.noLinkStyle, prefetch = props.prefetch, replace = props.replace, role = props.role, scroll = props.scroll, shallow = props.shallow, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(props, [
        "activeClassName",
        "as",
        "className",
        "href",
        "linkAs",
        "locale",
        "noLinkStyle",
        "prefetch",
        "replace",
        "role",
        "scroll",
        "shallow"
    ]);
    var enabled = (0,_contexts_CursorContext__WEBPACK_IMPORTED_MODULE_4__/* .useCursorContext */ .r)().enabled;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var storybook = router === null || router === void 0 ? void 0 : router.storybook;
    var _$ref;
    var pathname = typeof href === "string" ? href : (_$ref = href === null || href === void 0 ? void 0 : href.pathname) !== null && _$ref !== void 0 ? _$ref : "/";
    var className = (0,clsx__WEBPACK_IMPORTED_MODULE_9__["default"])(classNameProps, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, activeClassName, router.pathname === pathname && activeClassName));
    var isExternal = typeof href === "string" && (href.indexOf("http") === 0 || href.indexOf("mailto:") === 0);
    if (isExternal) {
        if (noLinkStyle) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(Anchor, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                className: className,
                href: enabled ? "#" : href,
                ref: ref
            }, other));
        }
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_mui_material_Link__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
            className: className,
            href: enabled ? "#" : href,
            ref: ref
        }, other));
    }
    var linkAs = linkAsProp || as;
    var nextjsProps = {
        to: enabled ? "#" : href,
        linkAs: linkAs,
        replace: replace,
        scroll: scroll,
        shallow: shallow,
        prefetch: prefetch,
        locale: locale,
        storybook: storybook
    };
    if (noLinkStyle) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(NextLinkComposed, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
            className: className,
            ref: ref
        }, nextjsProps, other));
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_mui_material_Link__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        component: NextLinkComposed,
        className: className,
        ref: ref
    }, nextjsProps, other));
});


/***/ }),

/***/ 92176:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I": function() { return /* binding */ BaseLayout; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/layouts/DefaultNestedLayout/index.tsx

/**
 * This component is used as fallback nested layout in case no layout component for a page
 * is set during a BigBang site build.
 *
 * This layout can be used as example "NestedLayout" component within our NPM framework.
 *
 * @param props LayoutProps
 * @constructor
 */ function DefaultNestedLayout(props) {
    var children = props.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: children
    });
}

;// CONCATENATED MODULE: ./src/layouts/DefaultLayout/index.tsx



/**
 * Extend the page view component with this component through "Component.getLayout".
 * This component is used as higher order component within _app.tsx.
 * https://nextjs.org/docs/basic-features/layouts
 * @param props LayoutProps
 * @constructor
 */ function DefaultLayout(props) {
    var children = props.children, pageContext = props.pageContext;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultNestedLayout, {
        pageContext: pageContext,
        children: children
    });
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@mui/material/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(98396);
// EXTERNAL MODULE: ./src/contexts/AppContext/index.tsx + 6 modules
var AppContext = __webpack_require__(13560);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./src/contexts/CursorContext/index.tsx
var CursorContext = __webpack_require__(15888);
;// CONCATENATED MODULE: ./src/layouts/LayoutB/LayoutB.tsx












var adsRequestImport = function(headerLift) {
    if (headerLift) {
        return (__webpack_require__(18505).adsRequest);
    }
    return null;
};
var AdvertisementSlot = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6585).then(__webpack_require__.bind(__webpack_require__, 29918)).then(function(mod) {
        return mod.AdvertisementSlot;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(29918)
            ];
        }
    },
    ssr: false
});
var Root = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eqs1sve0"
})(function() {
    return {
        display: "flex",
        flexDirection: "row",
        flexWrap: "nowrap",
        height: "auto"
    };
});
var Sides = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eqs1sve1"
})(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        display: "none"
    }, theme.breakpoints.up(1200), {
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        flexGrow: 0,
        flexWrap: "nowrap",
        height: "fit-content",
        justifyContent: "center",
        padding: theme.spacing(7, 2, 2)
    });
});
var AdvertisementSlotStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(AdvertisementSlot, {
    target: "eqs1sve2"
})(function(param) {
    var theme = param.theme;
    return {
        boxShadow: theme.shadows[0],
        margin: theme.spacing(0, 0, 4)
    };
});
var AdsLeft = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementSlotStyled, (0,_object_spread/* default */.Z)({
        slotIdentifier: props.id || "idhb-left-300",
        elevation: 1,
        alignment: "right"
    }, props));
};
var AdsLeftMiddle = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementSlotStyled, {
        slotIdentifier: props.id || "idhb-left-small-300",
        variant: "300x250",
        alignment: "right",
        elevation: 1
    });
};
var AdsRight = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementSlotStyled, (0,_object_spread/* default */.Z)({
        slotIdentifier: props.id || "idhb-right-300",
        alignment: "left",
        elevation: 1
    }, props));
};
var AdsRightMiddle = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementSlotStyled, {
        slotIdentifier: props.id || "idhb-right-small-300",
        variant: "300x250",
        alignment: "left",
        elevation: 1
    });
};
var LayoutB = function(props) {
    var children = props.children;
    var router = (0,next_router.useRouter)();
    var xlCustom = (0,useMediaQuery/* default */.Z)("(min-width:1560px)", {
        noSsr: true
    });
    var lgCustom = (0,useMediaQuery/* default */.Z)("(max-width:1559px) and (min-width:1280px)", {
        noSsr: true
    });
    var mdCustom = (0,useMediaQuery/* default */.Z)("(max-width:1279px) and (min-width:1200px)", {
        noSsr: true
    });
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(0), 2), leftSize = ref[0], setLeftSize = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(0), 2), rightSize = ref1[0], setRightSize = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)(react.useState([]), 2), banners = ref2[0], setBanners = ref2[1];
    var appContext = (0,AppContext/* useAppContext */.bp)();
    var ref3 = appContext.useConfig(), componentOptions = ref3.componentOptions, project = ref3.project;
    var header_lift = project.features.ads.header_lift;
    var theme = (0,useTheme/* default */.Z)();
    var lg = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up("lg"));
    var isBetweenMdAndLg = (0,useMediaQuery/* default */.Z)(theme.breakpoints.between("md", "lg"));
    var mdDown = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("md"));
    var panel = (0,CursorContext/* useCursorContext */.r)().panel;
    var adsRequest = react.useMemo(function() {
        return adsRequestImport(header_lift);
    }, [
        header_lift
    ]);
    var layoutAdsElements = {
        "idhb-left-300": !(componentOptions.component_layout_left_ads_disabled || componentOptions.component_layout_left_ads_tablet_disabled || componentOptions.component_layout_left_ads_mobile_disabled),
        "idhb-left-small-300": !(componentOptions.component_layout_left_middle_ads_disabled || componentOptions.component_layout_left_middle_ads_tablet_disabled || componentOptions.component_layout_left_middle_ads_mobile_disabled),
        "idhb-right-300": !componentOptions.component_layout_right_ads_disabled || false,
        "idhb-right-small-300": !componentOptions.component_layout_right_middle_ads_disabled || false
    };
    var bannerConditions = [
        {
            key: "idhb-left-300",
            condition: function(size) {
                return size > 0;
            }
        },
        {
            key: "idhb-left-small-300",
            condition: function(size) {
                return size >= 300;
            }
        },
        {
            key: "idhb-right-300",
            condition: function(size) {
                return size > 0;
            }
        },
        {
            key: "idhb-right-small-300",
            condition: function(size) {
                return size >= 300;
            }
        }, 
    ];
    react.useEffect(function() {
        if (xlCustom) {
            setLeftSize(300);
            setRightSize(300);
        } else if (lgCustom) {
            setLeftSize(160);
            setRightSize(160);
        } else if (mdCustom) {
            setLeftSize(120);
            setRightSize(120);
        } else {
            setLeftSize(0);
            setRightSize(0);
        }
    }, [
        xlCustom,
        lgCustom,
        mdCustom
    ]);
    react.useEffect(function() {
        if (!header_lift) {
            setBanners([]);
            return;
        }
        var updatedBanners = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = bannerConditions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _value = _step.value, key = _value.key, condition = _value.condition;
                var isElementEnabled = layoutAdsElements[key];
                if (isElementEnabled && condition(leftSize)) {
                    updatedBanners.push(key);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        setBanners(updatedBanners);
    }, [
        leftSize,
        rightSize,
        componentOptions,
        header_lift
    ]);
    react.useEffect(function() {
        if (header_lift && adsRequest && banners.length > 0 && !componentOptions.component_ads_disabled) {
            adsRequest(banners);
        }
    }, [
        banners,
        header_lift,
        adsRequest,
        componentOptions.component_ads_disabled
    ]);
    react.useEffect(function() {
        if (!header_lift || !adsRequest) return;
        var events = router.events;
        var handleRouteChange = function() {
            if (banners.length > 0) {
                adsRequest(banners);
            }
        };
        events.on("routeChangeComplete", handleRouteChange);
        events.on("hashChangeComplete", handleRouteChange);
        return function() {
            events.off("routeChangeComplete", handleRouteChange);
            events.off("hashChangeComplete", handleRouteChange);
        };
    }, [
        router,
        banners,
        header_lift,
        adsRequest
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Root, {
        children: [
            panel ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Sides, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdsLeft, {
                        variant: "".concat(leftSize, "x600")
                    }),
                    leftSize >= 300 && !componentOptions.component_layout_left_middle_ads_disabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdsLeftMiddle, {})
                ]
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: !componentOptions.component_ads_disabled && leftSize > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Sides, {
                    children: [
                        lg && !componentOptions.component_layout_left_ads_disabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdsLeft, {
                            id: componentOptions.component_left_ads_id,
                            variant: "".concat(leftSize, "x600")
                        }),
                        isBetweenMdAndLg && !componentOptions.component_layout_left_ads_tablet_disabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdsLeft, {
                            id: componentOptions.component_left_ads_id,
                            variant: "".concat(leftSize, "x600")
                        }),
                        mdDown && !componentOptions.component_layout_left_ads_mobile_disabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdsLeft, {
                            id: componentOptions.component_left_ads_id,
                            variant: "".concat(leftSize, "x600")
                        }),
                        leftSize >= 300 && !componentOptions.component_layout_left_middle_ads_disabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                            children: [
                                lg && !componentOptions.component_layout_left_middle_ads_disabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdsLeftMiddle, {
                                    id: componentOptions.component_left_middle_ads_id
                                }),
                                isBetweenMdAndLg && !componentOptions.component_layout_left_middle_ads_tablet_disabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdsLeftMiddle, {
                                    id: componentOptions.component_left_middle_ads_id
                                }),
                                mdDown && !componentOptions.component_layout_left_middle_ads_mobile_disabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdsLeftMiddle, {
                                    id: componentOptions.component_left_middle_ads_id
                                })
                            ]
                        })
                    ]
                })
            }),
            children,
            panel ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Sides, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdsRight, {
                        variant: "".concat(rightSize, "x600")
                    }),
                    rightSize >= 300 && !componentOptions.component_layout_right_middle_ads_disabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdsRightMiddle, {})
                ]
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: !componentOptions.component_ads_disabled && rightSize > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Sides, {
                    children: [
                        lg && !componentOptions.component_layout_right_ads_disabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdsRight, {
                            id: componentOptions.component_right_ads_id,
                            variant: "".concat(rightSize, "x600")
                        }),
                        isBetweenMdAndLg && !componentOptions.component_layout_right_ads_tablet_disabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdsRight, {
                            id: componentOptions.component_right_ads_id,
                            variant: "".concat(rightSize, "x600")
                        }),
                        mdDown && !componentOptions.component_layout_right_ads_mobile_disabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdsRight, {
                            id: componentOptions.component_right_ads_id,
                            variant: "".concat(rightSize, "x600")
                        }),
                        rightSize >= 300 && !componentOptions.component_layout_right_middle_ads_disabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                            children: [
                                lg && !componentOptions.component_layout_right_middle_ads_disabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdsRightMiddle, {
                                    id: componentOptions.component_right_middle_ads_id
                                }),
                                isBetweenMdAndLg && !componentOptions.component_layout_right_middle_ads_tablet_disabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdsRightMiddle, {
                                    id: componentOptions.component_right_middle_ads_id
                                }),
                                mdDown && !componentOptions.component_layout_right_middle_ads_mobile_disabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdsRightMiddle, {
                                    id: componentOptions.component_right_middle_ads_id
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/layouts/LayoutB/index.ts


;// CONCATENATED MODULE: ./src/generated/game/layout.tsx



function Layout(props) {
    var children = props.children, pageContext = props.pageContext;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LayoutB, {
        pageContext: pageContext,
        children: children
    });
}

;// CONCATENATED MODULE: ./src/layouts/BaseLayout/index.tsx




// IMPORTANT: The page.name in the import and switch case must match with the pageType set in the BaseLayoutProps definition!

var NavigationBar = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3818), __webpack_require__.e(4831), __webpack_require__.e(9615)]).then(__webpack_require__.bind(__webpack_require__, 22197)).then(function(mod) {
        return mod.NavigationBarB;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(22197)
            ];
        }
    },
    ssr: true
});
var FooterBar = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3818), __webpack_require__.e(4111)]).then(__webpack_require__.bind(__webpack_require__, 14111)).then(function(mod) {
        return mod.FooterBarB;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(14111)
            ];
        }
    },
    ssr: true
});
function BaseLayout(props) {
    var children = props.children, pageType = props.pageType, pageContext = props.pageContext;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavigationBar, {}),
            function() {
                switch(pageType){
                    case "game":
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Layout, {
                            pageContext: pageContext,
                            children: children
                        });
                    default:
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultLayout, {
                            pageContext: pageContext,
                            children: children
                        });
                }
            }(),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterBar, {})
        ]
    });
}


/***/ }),

/***/ 18505:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "adsRequest": function() { return /* binding */ adsRequest; }
/* harmony export */ });
var adsRequest = function(banners) {
    if (banners.length >= 1) {
        var ref;
        window.idhb = (window === null || window === void 0 ? void 0 : window.idhb) || {};
        window.idhb.que = ((ref = window.idhb) === null || ref === void 0 ? void 0 : ref.que) || [];
        window.idhb.que.push(function() {
            console.info("[hl]", banners);
            window.idhb.requestAds({
                // slotIds is optional. If not specified, ads for all configured slots on the page will be requested
                slotIds: banners
            });
        });
    }
};


/***/ })

}]);